import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {ZzFlatButtonRoute} from "core/components/buttons/buttons";
import {MODULE, PERMISSION, PageProps} from "core/metamodel/metaConstant";
import {PAGE} from "routes";
import mdEntityService from "core/metamodel/mdEntityService";
import {observer} from "mobx-react";
import {loc} from "core/common/config/locales";


const gridLocation = 'invoiceTemplateList';


@observer
export default class InvoiceTemplateList extends  PageAncestor<PageProps, undefined> {

  static module = MODULE.invoicing;
  static title = loc.i18n`Invoice Templates`;
  static icon = 'money';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("InvoiceTemplateList#fetchData(%s)", gridLocation);
    return gridService.fetchGrids(gridLocation)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(gridLocation);
      });
  }





  render() {
    let {params, query} = this.props;

    return (
      <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)}  entities={mdEntityService.entityMap} gridId={params.gridId} query={query} >
        <ZzFlatButtonRoute onGridToolbar routeName="invoiceTemplateDetail" params={{id: 'new'}} label={loc.i18n`New Template`} permission={PERMISSION.New} securable={PAGE.invoiceTemplateDetail}/>

      </GridCompConnected>
    );
  }

}



// WEBPACK FOOTER //
// ./src/invoice/page/invoiceTemplateList.tsx